import React from "react";
import { Widchart1, Widchart2, Widchart3, Widchart4 } from "./AllDashCharts";

const Widgets = () => {
  return (
    <React.Fragment>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
            <div>
              <p className="text-base dark:text-white/80">Total Views</p>
              <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
                15102
                <span className="p-1 text-sm leading-none rounded-md bg-success/20 text-success">
                  23%
                </span>
              </h4>
              <p className="text-muted">Current Month</p>
            </div>
            <div>
              <div id="chart" dir="ltr">
                <Widchart1 />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
            <div>
              <p className="text-base dark:text-white/80">Paid Visits</p>
              <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
                4581
                <span className="p-1 text-sm leading-none rounded-md bg-danger/20 text-danger">
                  24%
                </span>
              </h4>
              <p className="text-muted">Current Month</p>
            </div>
            <div>
              <div id="chart2" dir="ltr">
                <Widchart2 />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
            <div>
              <p className="text-base dark:text-white/80">Total Referral</p>
              <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
                2140
                <span className="p-1 text-sm leading-none rounded-md bg-danger/20 text-danger">
                  10%
                </span>
              </h4>
              <p className="text-muted">Current Month</p>
            </div>
            <div>
              <div id="chart4" dir="ltr">
                <Widchart4 />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between gap-6 p-5 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10">
            <div>
              <p className="text-base dark:text-white/80">This Week</p>
              <h4 className="flex items-center gap-4 mt-3 text-2xl font-semibold text-black dark:text-white">
                7714
                <span className="p-1 text-sm leading-none rounded-md bg-success/20 text-success">
                  82%
                </span>
              </h4>
              <p className="text-muted">Current Month</p>
            </div>
            <div>
              <div id="chart3" dir="ltr">
                <Widchart3 />
              </div>
            </div>
          </div>
        </div>
        
    </React.Fragment>
  );
};

export default Widgets;
